import { AuthenticationResult } from '@azure/msal-browser';

import { OidcTokens } from './oidcTokens';

export interface TokenResponseType {
	token_type: string;
	scope: string;
	expires_in: number;
	access_token: string;
	refresh_token: string;
	id_token: string;
}

export const parseTokenResponseTypeToOidcTokens = (
	tokenResponseType: TokenResponseType
): OidcTokens => {
	return {
		tokenType: tokenResponseType.token_type,
		scope: tokenResponseType.scope,
		expiresAt: Math.floor(Date.now() / 1000) + tokenResponseType.expires_in,
		expiresIn: tokenResponseType.expires_in,
		accessToken: tokenResponseType.access_token,
		refreshToken: tokenResponseType.refresh_token,
		idToken: tokenResponseType.id_token,
		isOtpFlow: true,
		canRefresh: true,
	};
};

export const parseAuthenticationResultToOidcTokens = (
	authenticationResult: AuthenticationResult
): OidcTokens => {
	return {
		tokenType: authenticationResult.tokenType,
		scope: authenticationResult.scopes.join(' '),
		expiresAt: (authenticationResult.expiresOn?.getTime() ?? 0) / 1000,
		expiresIn:
			(authenticationResult.expiresOn?.getTime() ?? 0) / 1000 - Math.floor(Date.now() / 1000),
		accessToken: authenticationResult.accessToken,
		idToken: authenticationResult.idToken,
		isOtpFlow: false,
		canRefresh: true,
	};
};
